import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { UnitMeasureService } from '../../../unit-measure.service';
import { UNIT_MEASURE_GROUP_TTL_ES } from '../../../unit-measure.interface';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';

@Component({
  selector: 'pg-unit-measure-create',
  templateUrl: './unit-measure-create.component.html'
})
export class UnitMeasureCreateComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  constructor(
    private fb: FormBuilder,
    private serviceBase: UnitMeasureService
  ) {
    super(UNIT_MEASURE_GROUP_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.fg = this.fb.group({
      description: [
        '',
        [Validators.required, Validators.minLength(3), Validators.maxLength(50)]
      ],
      symbol: [
        '',
        [Validators.required, Validators.minLength(3), Validators.maxLength(10)]
      ]
    });
  }

  onSubmit() {
    this.createItem$(this.fg.value);
  }
}
